import { useContext } from 'react';
import { SATConnectionContext } from './SATConnectionContext';
import type { SATConnectionContextValue } from './satConnection.types';

export const useSATConnection = (): SATConnectionContextValue => {
	const ctx = useContext(SATConnectionContext);
	if (!ctx) {
		throw new Error(
			'useSATConnection must be used inside a <SATConnectionProvider>',
		);
	}
	return ctx;
};
